import React, { useState, useEffect, useRef, useCallback } from "react";
import SharesDataService from "../services/SharesService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const SharesPr = (props) => {
  const [shares, setShares] = useState([]);
  const sharesRef = useRef();
  sharesRef.current = shares;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveShares = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    SharesDataService.getAll(target)
      .then((response) => setShares(response.data || []))
      .catch((e) => { console.error(e); setShares([]); });
  }, [owner]);

  useEffect(() => { retrieveShares(); }, [retrieveShares]);

  const deleteShares = useCallback((rowIndex) => {
    const id = sharesRef.current[rowIndex].id || sharesRef.current[rowIndex]._id;
    SharesDataService.remove(id)
      .then(() => {
        const newArr = [...sharesRef.current];
        newArr.splice(rowIndex, 1);
        setShares(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/shares/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/shares/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = sharesRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteShares(idx);
  }, [deleteShares]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={shares}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default SharesPr;
